import React from 'react'
import { FormSingE } from '../../ui/FormSingE/FormSingE'
import { SliderSing } from '../../ui/SliderSing/SliderSing'

export const ContainerSingE = () => {
  return (
    <div className="ContainerSingE">
        <FormSingE/>
        <SliderSing/>
    </div>
  )
}
